import * as React from "react";
import { useNotification } from "@refinedev/core";
import { handleError } from "@/providers/errorHandler";

type BffErrorEvent = {
  code?: string;
  message?: string;
  traceId?: string;
};

export function GlobalErrorHandler(): null {
  const { open } = useNotification();

  React.useEffect(() => {
    const handleUnhandledRejection = (event: PromiseRejectionEvent): void => {
      const error = event.reason as BffErrorEvent | undefined;
      if (!error?.code) return;

      const action = handleError({
        code: error.code,
        message: error.message ?? "",
        traceId: error.traceId ?? "",
      });

      if (action.type === "rate_limit") {
        open?.({
          type: "error",
          message: action.userMessage,
          description: "Превышен лимит запросов",
        });
        event.preventDefault();
      } else if (action.type === "role_changed") {
        open?.({
          type: "error",
          message: action.userMessage,
          description: "Требуется обновление страницы",
        });
        event.preventDefault();
      }
    };

    window.addEventListener("unhandledrejection", handleUnhandledRejection);
    return () => {
      window.removeEventListener("unhandledrejection", handleUnhandledRejection);
    };
  }, [open]);

  return null;
}
